import { render, staticRenderFns } from "./ServisZaKupce.vue?vue&type=template&id=5e67b39e"
import script from "./ServisZaKupce.vue?vue&type=script&lang=js"
export * from "./ServisZaKupce.vue?vue&type=script&lang=js"
import style0 from "./ServisZaKupce.vue?vue&type=style&index=0&id=5e67b39e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports